"use client";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { trackClientError } from "@/lib/client-error";
import { AlertTriangle, Home } from "lucide-react";
import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    trackClientError(error, { tags: { scope: "global-error-boundary" } });
  }, [error]);

  const handleHomeClick = () => {
    window.location.href = "/";
  };

  return (
    <html lang="en">
      <body>
        <div className="flex min-h-screen w-full flex-col items-center justify-center p-4">
          <div className="w-full max-w-2xl space-y-6">
            <Alert variant="destructive" className="mb-6">
              <AlertTriangle className="h-5 w-5" />
              <AlertTitle>Critical Error</AlertTitle>
              <AlertDescription className="mt-2">
                <div className="space-y-2">
                  <p>We encountered a serious error while loading the page.</p>
                  {error.message && (
                    <p className="font-mono text-sm">Error: {error.message}</p>
                  )}
                  {error.digest && (
                    <p className="font-mono text-sm">Digest: {error.digest}</p>
                  )}
                </div>
              </AlertDescription>
            </Alert>

            <div className="flex justify-center">
              <Button onClick={handleHomeClick} className="gap-2">
                <Home className="h-4 w-4" />
                Return Home
              </Button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
